const registerData = {
    firstName: "",
    surname: "",
    email: "",
    password: ""
}

const BASE_URL = "https://backend.skilltrack.fun/api"

function showErrorPopup(message) {
      const popup = document.getElementById("errorPopup");
      const errorMessage = document.getElementById("errorMessage");
      errorMessage.textContent = message || "There was an error generating the quiz.";
      popup.classList.remove("hidden");
      popup.classList.add("show");
      
      // Hide the popup after 3 seconds
          setTimeout(() => {
          popup.classList.remove("show");
          popup.classList.add("hidden");
          }, 3000);
          }


function showSuccessPopup() {
        const popup = document.getElementById("successPopup");
        popup.classList.remove("hidden");
        popup.classList.add("show");

        // Hide the popup after 3 seconds
        setTimeout(() => {
          popup.classList.remove("show");
          popup.classList.add("hidden");
        }, 3000);
      }

const  handleRegister = async(data) => {
  const url = `${BASE_URL}/auth/signup`;

  try {
    const response = await fetch(url, {
      method: "POST",
       headers: {
        "Content-Type": "application/json", // Set the content type to JSON
      },
      body : JSON.stringify(data)
    });
    const response1 = await response.json();
     if (response1?.status === 200) {

       localStorage.setItem("token",JSON.stringify(response1?.data?.token))
       localStorage.setItem("user",JSON.stringify(response1?.data?.user))
        showSuccessPopup();
      // Redirect to the specified URL
      window.location.href = "https://skilltrack.fun/en?_ab=0&_fd=0&_sc=1";
    } else {
      // Handle other statuses or show an error message
        showErrorPopup(response1?.message); 
      console.error("Unexpected status:", response1?.status);
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
  
}

const handelChange = (event) => {
  const {firstName,surname,email,password} = event.target
   formData[name] = value;
  
}

const handleFirstName = (event) => {
  let firstName = event.target.value
  registerData.firstName = firstName 
}

const handleSurName = (event) => {
  let surname = event.target.value
   registerData.surname = surname 
}


const handleEmail = (event) => {
  let email = event.target.value
   registerData.email = email 
}

const handlePassword = (event) => {
  let password = event.target.value
   registerData.password = password 
}

const  handleSignup = () => {
  console.log("registerData",registerData)
  handleRegister(registerData)
}